export default "__VITE_ASSET__kuBfIM10__"